module.exports = __webpack_public_path__ + "26915dcb0bb8178264eb20213dfe28ab.jpg";